import { render, staticRenderFns } from "./RegionWordsHint.vue?vue&type=template&id=3946a395&scoped=true"
import script from "./RegionWordsHint.vue?vue&type=script&lang=js"
export * from "./RegionWordsHint.vue?vue&type=script&lang=js"
import style0 from "./RegionWordsHint.vue?vue&type=style&index=0&id=3946a395&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3946a395",
  null
  
)

export default component.exports